<template>
  <DBox
    :id="'cmp-royalty-royalty_accounts-account_setup'"
    :addButton="false"
    :addLink="false"
  >
    <TextField2
      :id="'royalty_account_name'"
      :placeholder="$t('royalty_account_name')"
      :label="$t('royalty_account_name')"
      :value="royaltyAccount.royalty_account_name"
      :lw="'135px'"
      @blur="onTextFieldValueChange"
    />
    <Dropdown2
      style="max-width:100%"
      :label="$t('Status')"
      :placeholder="$t('status')"
      :options="selectedAccountDetails.labelStatusesTV"
      :selected="
        selectedAccountDetails.labelStatusesTV.find(
          (e) =>
            e.value == selectedAccountDetails.royalty_account.label_status_id
        )
      "
      :lw="'135px'"
      v-on:selectedChange="(e) => onDropdownChange('label_status_id', e)"
      status
    />
    <!-- <div class="fc2 fc2-row ut-flex">
      <label class="fc2-label txtov">{{
        $dft.snakeCaseToWords("status")
      }}</label>

      <div class="ut-flex no-left-padding">
        <div
          class="no-label"
          v-for="status in statuses"
          :key="status.label_status_id"
        >
          <span
            v-if="
              selectedAccountDetails.royalty_account.label_status_id ==
              status.label_status_id
            "
            class="circle"
            :style="{
              backgroundColor: `#${status.label_status_colour}`,
            }"
          ></span>
        </div>
        <Dropdown2
          :label="$t('Status')"
          :showLabel="false"
          :placeholder="$t('status')"
          :options="selectedAccountDetails.labelStatusesTV"
          :selected="
            selectedAccountDetails.labelStatusesTV.find(
              (e) =>
                e.value ==
                selectedAccountDetails.royalty_account.label_status_id
            )
          "
          :lw="'135px'"
          :bb="'none'"
          v-on:selectedChange="(e) => onDropdownChange('label_status_id', e)"
        />
      </div>
    </div> -->

    <Dropdown2
      :label="$t('royalty_period')"
      :placeholder="$t('royalty_period')"
      :options="selectedAccountDetails.royalty_periodsTV"
      :selected="
        selectedAccountDetails.royalty_periodsTV.find(
          (e) =>
            e.value == selectedAccountDetails.royalty_account.royalty_period
        )
      "
      :lw="'135px'"
      :listHeight="dropDownListHeightCalculate(selectedAccountDetails.royalty_periodsTV)"
      v-on:selectedChange="(e) => onDropdownChange('royalty_period', e)"
    />
    <TextField2
      :id="'min_payment'"
      :placeholder="$t('minimum_payment')"
      :label="$t('minimum_payment')"
      :value="royaltyAccount.min_payment"
      :lw="'135px'"
      @blur="onTextFieldValueChange"
    />
    <Dropdown2
      :label="$t('Account Base')"
      :disabled="hasRoyaltyPeriods"
      :options="selectedAccountDetails.account_baseTV"
      :selected="
        selectedAccountDetails.account_baseTV.find(
          (e) =>
            e.value == selectedAccountDetails.royalty_account.payment_yes_no
        )
      "
      :placeholder="$t('Account Base')"
      :lw="'135px'"
      v-on:selectedChange="(e) => onDropdownChange('payment_yes_no', e)"
    />
    <Dropdown2
      :label="$t('royalty_project')"
      :placeholder="$t('royalty_project')"
      :options="selectedAccountDetails.invoice_projectsTV"
      :selected="
        selectedAccountDetails.invoice_projectsTV.find(
          (e) =>
            e.value == selectedAccountDetails.royalty_account.invoice_project_id
        )
      "
      :lw="'135px'"
      
      v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
    />

    <TextField2
      v-if="believe_special"
      :disabled="'disabled'"
      :id="'royalty_account_id'"
      :placeholder="$t('royalty_account')"
      :label="$t('royalty_account')"
      :value="royaltyAccount.royalty_account_id"
      :lw="'135px'"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      v-if="believe_special"
      :id="'json_data'"
      :placeholder="$t('aliases')"
      :label="$t('aliases')"
      :value="royaltyAccount.json_data"
      :lw="'135px'"
      @blur="onTextFieldValueChange"
    />
    <Dropdown2
      v-if="believe_special"
      :label="$t('legal_company')"
      :options="selectedAccountDetails.companiesTV"
      :selected="
        selectedAccountDetails.companiesTV.find(
          (e) => e.value == selectedAccountDetails.royalty_account.company_id
        )
      "
      :lw="'135px'"
      :placeholder="$t('legal_company')"
      v-on:selectedChange="(e) => onDropdownChange('company_id', e)"
    />
    <Dropdown2
      bb="none"
      :label="$t('mailing')"
      :options="mailingTV"
      :disabled="isDisabled"
      :selected="mailingTV.find((e) => e.value == statement_type)"
      :lw="'135px'"
      :placeholder="$t('mailing')"
      v-on:selectedChange="(e) => onDropdownChange('statement_type', e)"
    />
    <Dropdown2
      bb="none"
      v-if="believe_special"
      :label="$t('access_type')"
      :options="accessTypeTV"
      :selected="
        accessTypeTV.find(
          (e) =>
            e.value ==
            selectedAccountDetails.royalty_account.believe_access_email
        )
      "
      :lw="'135px'"
      :placeholder="$t('access_type')"
      v-on:selectedChange="(e) => onDropdownChange('believe_access_email', e)"
    />
  </DBox>
</template>



<script>
import { dropDownListHeightCalculate } from '../../../../utility';

export default {
  props: ["selectedAccountDetails"],

  computed: {
    believe_special() {
      return this.$store.getters.account.believe_special;
    },
    royaltyAccount: function () {
      return this.selectedAccountDetails.royalty_account || {};
    },
    statuses: function () {
      return this.selectedAccountDetails?.label_statuses || [];
    },
    mailingTV: function () {
      return this.selectedAccountDetails?.related_ext_users?.length > 0
        ? [{ text: "B2B", value: 1 }]
        : [
            { text: "Send manually", value: 1 },
            { text: "Send automatically", value: 2 },
            { text: "Do not send", value: 3 },
          ];
    },
    isDisabled: function () {
      return this.selectedAccountDetails?.related_ext_users?.length > 0
        ? true
        : false;
    },
    statement_type: function () {
      return this.selectedAccountDetails?.related_ext_users?.length > 0
        ? 1
        : this.selectedAccountDetails.royalty_account.statement_type;
    },
    accessTypeTV: function () {
      return [
        { text: "Access from backstage", value: "email_code_backstage" },
        { text: "Direct access", value: "email_code" },
      ];
    },
    backgroundColor: function () {
      return this.royaltyAccount?.label_status_id === 1
        ? "#1B44A6"
        : "rgb(227, 66, 66)";
    },
    hasRoyaltyPeriods: function () {
      return this.selectedAccountDetails?.statement_data?.length > 0
        ? true
        : false;
    },
  },
  watch: {},

  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      console.log("name", name, value.value);
      this.$emit("changed", { name, value: value.value });
    },
    dropDownListHeightCalculate:dropDownListHeightCalculate
    
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-account_setup {
  .status {
    max-width: fit-content !important;
  }
  .form-group .input_box {
    padding: 0px 5px;
  }
  .fc2-row {
    //--fc2-tf-padding: 0px 0px;
    //--fc2-tf-margin: 3px 3px 3px 0px;
    --bb: 1px solid var(--sprt-85);

    height: 30px;
    border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      &.no-left-padding {
        padding-left: 0;
      }

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }

    .dropdown-2 {
      flex: 1;
    }

    .no-label {
      .fc2-label {
        display: none;
      }
    }
    .circle {
      margin-left: 10px;
    }
  }
}
</style>